import { render, staticRenderFns } from "./ElderlyGovAll.vue?vue&type=template&id=e5d45052&scoped=true&"
import script from "./ElderlyGovAll.vue?vue&type=script&lang=js&"
export * from "./ElderlyGovAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d45052",
  null
  
)

export default component.exports